import React, { useEffect, useState, useRef, useContext } from "react";
import { IoClose } from "react-icons/io5";
import { ProjectContext } from "../../ProjectContext";
import { useNavigate } from "react-router-dom";
import { useConnectModal } from "@rainbow-me/rainbowkit";

const DailyNYOModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const modalRef = useRef(null);

  const toggleHeader = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);
  const {
    copyaddress,
    account,
    toastSuccess,
    library,
    dbuser,
    formatAddress,
    toastError,
    settings,
    esigner,
    ethers,
    Refaddress,
    getuserDB,
    x2balance,
    tokenrate,
    dbbalance,
    Maincontract, Usdtcontract, RMinW, PDailyReward, dnetcontract, Maincontract1, getsmcs,
  } = useContext(ProjectContext);

  const [selectedCrypto, setSelectedCrypto] = useState(0);
  const handleSelect = (crypto) => {
    setSelectedCrypto(crypto);
  };

  const [show, setShow] = useState(false);
  const [amount, setAmount] = useState("");
  const [trdone, setTrdone] = useState(false);
  const [hash, setHash] = useState("");
  const [referral, setReferral] = useState("");
  const [Pkg, setPkg] = useState("");
  const [loading, setLoading] = useState(false); // New loading state to handle the loader
  const [rcv_amount, setrcv_amount] = useState(0);
  const [fees, setfees] = useState(0);
  const [total_tokens, settotal_tokens] = useState(0);
  const [RUsdt, setRUsdt] = useState(0);
  const [rate, setRate] = useState(0); // State to store the rate
  const [errorMessage, setErrorMessage] = useState(""); // For showing error message

  const { openConnectModal } = useConnectModal();
  var navigate = useNavigate();

  const withdrawal = async () => {
    setTrdone(true);
    setHash("");
    setLoading(true); // Set loading to true when the transaction starts

    if (!account) {
      openConnectModal();
      toastError("Connect first");
      setTrdone(false);
      setLoading(false); // Stop loading if no account
      return;
    }

    if (parseFloat(amount) < RMinW) {
      toastError(`Amount must be at least  $ ${RMinW} required`);
      setErrorMessage(`Amount must be at least "$"${RMinW}`);
      setTrdone(false);
      setLoading(false);
      return;
    }

    if (PDailyReward < amount) {
      toastError("Insufficient balance!");
      setTrdone(false);
      setLoading(false);
      return;
    }

    try {
      const stk = await Maincontract1.claim(ethers.utils.parseUnits(amount, 6).toString(), 2);
      const receipt = await stk.wait();
      setHash(receipt.transactionHash);
      toastSuccess("Transaction done");
      getsmcs();
      setAmount(""); // Clear amount after transaction
      setErrorMessage(""); // Clear any error messages
    } catch (error) {
      if (error.code === "CALL_EXCEPTION" && error.data) {
        toastError(`Transaction failed: ${error.data.message || "Unknown error"}`);
      } else {
        toastError(`Transaction failed: ${error.message}`);
      }
    } finally {
      setTrdone(false);
      setLoading(false); // Stop loading after transaction is complete or failed
    }
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    setAmount(value);

    // Clear any previous error message when user starts typing
    if (value && parseFloat(value) < RMinW) {
      setErrorMessage(`Amount must be at least $ ${RMinW}`);
    } else {
      setErrorMessage(""); // Clear error message if valid
    }
  };

  const fetchData = async () => {
    // console.log("DATA1", amount);

    try {
      // Perform calculations for token values
      // const tmt = await Maincontract.calculatetoken(ethers.utils.parseUnits(amount.toString(), 6).toString());
      // console.log("TMT", tmt.toString());
      const tmtUST = (amount * 5) / 100; // 1% fee in USD equivalent (not token amount)
      // const tmtfee = await Maincontract.calculatetoken(ethers.utils.parseUnits(tmtUST.toString(), 6).toString()); // 1% fee
      // const rcvAmount = await Maincontract.calculatetoken(ethers.utils.parseUnits((amount - tmtUST).toString(), 6).toString());

      // Update the state with the results
      setRUsdt(amount - tmtUST); // USDT equivalent after fee
      settotal_tokens(tmtUST); // Total tokens after fee
      // setfees(ethers.utils.formatUnits(tmtfee.toString(), 6)); // Fee
      // // console.log("rcvAmount.toString()", rcvAmount.toString());
      // const formattedAmount = ethers.utils.formatUnits(rcvAmount.toString(), 6);

      // setrcv_amount(formattedAmount);
      const max = await dnetcontract.MAX_GLOBAL_DAILY_SELL();
      console.log("max", Number(ethers.utils.formatUnits(max.toString(), 6)));
      const maxlimit = Number(ethers.utils.formatUnits(max.toString(), 6));
      // if (formattedAmount > maxlimit) {
      //   toastError(`Max Token limit is ${maxlimit}`);

      //   return;
      // }

    } catch (error) {
      console.error("Error calculating token values:", error);
      toastError("Error calculating token values");
    }
  };

  useEffect(() => {
    // Check if the necessary data is available
    if (amount) {
      fetchData();
    }
  }, [rate, tokenrate, amount]);

  return (
    <>
      {/* Button to trigger modal */}

      <button className="button-1  px-5 my-2 mx-2 my-lg-0 w-100" onClick={toggleHeader}>
        <div className="dots_border" />
        <img
          src="../assets/images/lock-icon.png"
          className="sparkle img-fluid"
          alt="lock-icon"
        />
        <span className="text_button">Daily NYO</span>
      </button>

      {/* Modal */}
      {isOpen && (
        <div
          className="modal fade show d-block"
          id="exampleModalCente2"
          style={{ background: "rgb(0 0 0 / 93%)" }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            role="document"
            ref={modalRef}
          >
            <div className="modal-content new-box">
              <div className="modal-header">
                <h5 className="modal-title text-white">Daily NYO</h5>
                <a onClick={toggleHeader} className="c-pointer">
                  <IoClose size={30} />
                </a>
              </div>
              <div className="modal-body">
                {hash ?
                  <div className="d-flex justify-content-center">
                    <img src="./../assets/img/tr_done.gif" width={150} />
                  </div>
                  :
                  <>
                    <div className="mb-3">
                      <div className="d-flex justify-content-between mt-3">
                        <label className="form-label text-white">Amount</label>
                        <label className="form-label text-white">$ {PDailyReward}</label>
                      </div>{" "}
                      <input
                        type="number"
                        className="form-control mt-2 mb-3 py-4"
                        style={{ borderRadius: "10px", borderColor: "gray" }}
                        value={amount}
                        onChange={handleAmountChange}
                        placeholder="Enter Amount"
                        disabled={loading} // Disable input while loading
                      />
                    </div>
                    {errorMessage ? (
                      <div className="text-danger mt-2">{errorMessage}</div>
                    ) : (
                      <>
                        {/* Display calculated fee and received amount */}
                        {amount && (
                          <div className="my-3 text-center">
                            <p>Fee 1% :  ${total_tokens.toFixed(2)}</p>
                            <h3 className="mb-0">${RUsdt}</h3>
                            <p className="mb-0">Received Amount</p>
                          </div>
                        )}
                      </>
                    )}
                  </>
                }
                <div className="d-flex justify-content-center">
                  {PDailyReward < 0 ? " " :
                    <>
                      <button
                        type="button"
                        onClick={() => withdrawal()}
                        className="btn btn-sm text-white bg-new-primary text-start"
                        disabled={loading} // Disable the button while loading
                      >
                        {loading ? "Processing..." : "Claim"}
                      </button>
                    </>
                  }
                </div>
                {loading && (
                  <div className="d-flex justify-content-center mt-3">
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                )}
                {hash && (
                  <div className="mt-3 text-center">
                    <h4>
                      <a
                        href={`${process.env.REACT_APP_EXPLORER}tx/${hash}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {formatAddress(hash)}
                      </a>
                      &nbsp;<i className="fa fa-copy" onClick={() => copyaddress(hash)}></i>
                    </h4>
                    <p>Transaction Hash</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DailyNYOModal;
